import { render } from "./FormHeading.vue?vue&type=template&id=7046d6a2"
import script from "./FormHeading.vue?vue&type=script&lang=js"
export * from "./FormHeading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__